import React from 'react';
import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';

import { assertExhaustiveSwitch } from '@paragon/utilities';

import { getSelectionWindowMode } from '../../../library/selection/window-tool/modes';
import { WindowToolTargetType } from '../../../library/selection/window-tool/types';
import { getPickingObjectInfo } from '../../../store/selectors/pickingSelectors';
import { configureSelectionWindowTool } from '../../../store/slices/selectionsSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { StandardFloatingBox } from './common/StandardFloatingBox';

export function SelectionWindowSettingsFloatingBox() {
  const dispatch = useAppDispatch();

  const isSelectionWindowToolEnabled = useAppSelector((state) => state.selections.isSelectionWindowToolEnabled);
  const pickingObjectInfo = useAppSelector(getPickingObjectInfo);
  const isActive = isSelectionWindowToolEnabled && !pickingObjectInfo;

  const mode = useAppSelector(getSelectionWindowMode);
  const settings = useAppSelector((state) => state.selections.selectionWindowSettings);

  if (!isActive) return null;

  return (
    <StandardFloatingBox>
      <Stack direction="column" spacing={1}>
        <Typography variant="h5" gutterBottom>
          Multiselect
        </Typography>

        {(() => {
          switch (mode) {
            case 'layout':
              return (
                <RadioGroup
                  value={settings.layout}
                  onChange={(_, value) => {
                    dispatch(
                      configureSelectionWindowTool({
                        mode: 'layout',
                        selectedType: value as WindowToolTargetType,
                      }),
                    );
                  }}
                >
                  <FormControlLabel value="trussEnvelope" label="Truss Envelopes" control={<Radio size="small" />} />
                  <FormControlLabel value="beam" label="Beams" control={<Radio size="small" />} />
                  <FormControlLabel value="wall" label="Walls" control={<Radio size="small" />} />

                  <FormControlLabel value="roofPlane" label="Roof Planes" control={<Radio size="small" />} />
                  <FormControlLabel value="ceilingPlane" label="Ceiling Planes" control={<Radio size="small" />} />
                  <FormControlLabel value="ceilingTray" label="Ceiling Trays" control={<Radio size="small" />} />

                  <FormControlLabel value="workLine" label="Work Lines" control={<Radio size="small" />} />
                  <FormControlLabel value="featureArea" label="Chases & Steps" control={<Radio size="small" />} />
                  <FormControlLabel
                    value="featurePatternContainer"
                    label="Feature Pattern Containers"
                    control={<Radio size="small" />}
                  />
                </RadioGroup>
              );

            case 'webbing':
              return (
                <RadioGroup value="webSegment">
                  <FormControlLabel value="webSegment" label="Web Segments" control={<Radio size="small" />} />
                </RadioGroup>
              );

            case 'design':
              return (
                <RadioGroup
                  value={settings.design}
                  onChange={(_, value) => {
                    dispatch(
                      configureSelectionWindowTool({
                        mode: 'design',
                        selectedType: value as WindowToolTargetType,
                      }),
                    );
                  }}
                >
                  <FormControlLabel value="member" label="Members" control={<Radio size="small" />} />
                  <FormControlLabel value="platePair" label="Plate Pairs" control={<Radio size="small" />} />
                </RadioGroup>
              );

            default:
              assertExhaustiveSwitch(mode);
          }
        })()}
      </Stack>
    </StandardFloatingBox>
  );
}
